import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert2";
import * as Icon from "react-feather";
import PuffLoader from "react-spinners/PuffLoader";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import { Switch } from "antd";

const ZoomMeeting = () => {
    const [selectedPlan, setSelectedPlan] = useState('');
    const [wordData, setwordData] = useState([]);
    const [showTotal, setTotalShow] = useState("");
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setperPage] = useState(10);
    const [totalPages, setotalPages] = useState(0);
    const [neww, setNeww] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [plans, setPlans] = useState([]);

    const handlePerPageChange = (event) => {
        const perpage = parseInt(event.target.value);
        setperPage(perpage);
        fetchData(0, query, perpage); // reset to first page when perPage changes
    };

    const handlePageClick = (page) => {
        fetchData(page, query, perPage);
    };

    const fetchData = async (page = 1, query = "", limit = perPage) => {
        setLoading(true);
        try {
            const api = await axios.get(`/api/v1/adm/zoom/db-meetings`, {
                params: {
                    page,
                    limit,
                    search: query
                },
            });

            setwordData(api?.data?.data || []);
            setCurrentPage(page);
            setotalPages(api?.data?.last_page || 0);
            setTotalShow(
                `Showing ${api?.data?.from || 0} to ${api?.data?.to || 0} of ${api?.data?.total || 0} entries`
            );
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    const deleteItem = async id => {
        try {
            const api = await axios.delete(`/api/v1/adm/zoom/meeting/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });
            const newwordData = wordData.filter(item => {
                return item.id !== id;
            });
            // alert(api.data.message);
            swal.fire("Deleted!", "Mock test has been successfully Deleted.", "success");
            setwordData(newwordData);
            setNeww(true)
        } catch (err) {
            // console.log("something went wrong!");
            swal.fire({
                title: "Error deleting item",
                text: err.message,
                icon: "error",
            });
        }
    };
    const handleDelete = id => {
        swal
            .fire({
                title: "Are you sure?",
                text: "You won't be delete this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            })
            .then(result => {
                if (result.isConfirmed) {
                    deleteItem(id);
                }
            });
    };
    const handleSwitchToggle = async (id) => {
        try {
            await axios.put(`/api/v1/adm/user-plan-sub-status?subscribe_id=${id}`);
            swal.fire("Updated!", "Status has been updated successfully.", "success");
            fetchData(currentPage, query, perPage);
        } catch (error) {
            // Handle errors, show an error message, etc.
            console.error("Error updating switch status:", error);
            swal.fire({
                title: "Error",
                text: "Failed to update switch status.",
                icon: "error",
            });
        }
    };

    const handleCopyUrl = (url) => {
        if (!url) {
            swal.fire("Error", "URL not available", "error");
            return;
        }

        navigator.clipboard.writeText(url)
            .then(() => {
                swal.fire({
                    icon: "success",
                    title: "Copied!",
                    text: "Join URL copied to clipboard",
                    timer: 1500,
                    showConfirmButton: false,
                });
            })
            .catch(() => {
                swal.fire("Error", "Failed to copy URL", "error");
            });
    };

    useEffect(() => {
        fetchData();
    }, [])

    const handleStatusToggle = async (meetingId, currentStatus) => {
        const isEnabling = currentStatus === 0;
        const newStatus = isEnabling ? 1 : 0;

        const result = await swal.fire({
            title: isEnabling ? "Enable meeting?" : "Disable meeting?",
            text: isEnabling
                ? "Students will be able to join this meeting."
                : "Students will NOT be able to join this meeting.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: isEnabling ? "Yes, enable" : "Yes, disable",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });

        if (!result.isConfirmed) return;

        try {
            await axios.put(
                `/api/v1/adm/zoom/meeting/status/${meetingId}`,
                { status: newStatus }
            );

            swal.fire(
                "Updated!",
                `Meeting has been ${isEnabling ? "enabled" : "disabled"} successfully.`,
                "success"
            );

            // Optimistic UI update
            setwordData(prev =>
                prev.map(item =>
                    item.id === meetingId
                        ? { ...item, status: newStatus }
                        : item
                )
            );
        } catch (error) {
            console.error(error);
            swal.fire("Error!", "Failed to update meeting status", "error");
        }
    };

    const getOccurrenceParts = (time) => {
        const d = new Date(time);

        return {
            day: d.toLocaleDateString("en-US", { weekday: "long" }),
            date: d.toLocaleDateString("en-US", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }),
            time: d.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            }),
        };
    };

    const handleViewOccurrences = (meeting) => {
        if (!meeting?.occurrences || meeting.occurrences.length === 0) {
            swal.fire("No Occurrences", "No occurrences found for this meeting.", "info");
            return;
        }

        const tableRows = meeting.occurrences
            .map((occ) => {
                const { day, date, time } = getOccurrenceParts(occ.start_time);
                return `
                <tr>
                    <td style="padding:8px; color:#222;">${day}</td>
                    <td style="padding:8px; color:#222;">${date}</td>
                    <td style="padding:8px; color:#222;">${time}</td>
                </tr>
            `;
            })
            .join("");

        const tableHtml = `
        <div style="max-height:300px; overflow-y:auto;">
            <table style="width:100%; border-collapse:collapse; text-align:left;">
                <thead>
                    <tr>
                        <th style="border-bottom:1px solid #ddd; font-weight:600; color:#222; padding:8px;">Day</th>
                        <th style="border-bottom:1px solid #ddd; font-weight:600; color:#222; padding:8px;">Date</th>
                        <th style="border-bottom:1px solid #ddd; font-weight:600; color:#222; padding:8px;">Time</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableRows}
                </tbody>
            </table>
        </div>
    `;

        swal.fire({
            title: `
            <div style="font-size:16px;">
                <strong>Meeting ID:</strong> ${meeting.zoom_meeting_id}<br/>
                <strong>Total Occurrences:</strong> ${meeting.occurrences.length}
            </div>
        `,
            html: tableHtml,
            width: 650,
            confirmButtonText: "Close",
        });
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchData(1, query, perPage);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [query]);


    return (
        <Layout>
            <div className="page-content">
                <div className="row">
                    <div className="col-md-12 col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 className="col-md-10 col-lg-10 card-title text-start">User Plan Assign List</h6>
                                    <Link to="/create-zoom-meeting">
                                        <button className="btn btn-primary">
                                            Create New Meeting
                                        </button>
                                    </Link>
                                </div>
                                <div className="d-flex mt-3 mb-3">
                                    <div className="col-sm-12 col-md-4 col-lg-4">
                                        <div className='d-flex align-items-center ms-3'>
                                            <label className="form-check-label mx-1">Show</label>
                                            <select className="form-select form-select-sm w-25 d-sm-inline-block mx-2" name="perpage" onChange={handlePerPageChange}>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <label className="form-check-label"> entries</label>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-4 col-lg-4">
                                        <div className="dataTables_paginate paging_simple_numbers" id="dataTableExample_paginate">
                                            <input
                                                value={query}
                                                onChange={(e) => setQuery(e.target.value)}
                                                type="search"
                                                className="form-control"
                                                placeholder="Search"
                                                aria-controls="dataTableExample"
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-1 col-md-1"><button className="btn btn-primary" onClick={() => console.log('reset')}>Reset</button></div> */}
                                </div>
                                <div className="table-responsive">
                                    {loading ? (
                                        <div className="data_loader">
                                            <PuffLoader color="#6571ff" />
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Meeting ID</th>
                                                <th>Topic</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                                <th>Recurrence</th>
                                                <th>Weekly Days Names</th>
                                                <th>Status</th>
                                                <th>Student Join URL</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {wordData.map((mocktest, i) => {
                                                const start_date = new Date(mocktest?.start_time).toLocaleString("en-AU", { timeZone: "Australia/Sydney" });
                                                const end_date = new Date(mocktest?.end_date).toLocaleString("en-AU", { timeZone: "Australia/Sydney" });
                                                return (
                                                    <tr key={i}>
                                                        <th>{mocktest?.zoom_meeting_id}</th>
                                                        <td>{mocktest.topic}</td>
                                                        <td>{start_date}</td>
                                                        <td>{end_date}</td>
                                                        <td>
                                                            {mocktest.recurrence_type}
                                                        </td>
                                                        <td>{mocktest.weekly_days_names?.length > 0 ? mocktest.weekly_days_names?.map(val => val).join(', ') : "N/A"}</td>
                                                        <td>
                                                            <Switch
                                                                checked={mocktest.status === 1}
                                                                checkedChildren="ON"
                                                                unCheckedChildren="OFF"
                                                                onChange={() =>
                                                                    handleStatusToggle(mocktest.id, mocktest.status)
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            {mocktest?.join_url ? (
                                                                <>
                                                                    <button
                                                                        className="btn"
                                                                        style={{ marginTop: "-10px" }}
                                                                        title="Copy Join URL"
                                                                        onClick={() => handleCopyUrl(mocktest.join_url)}
                                                                    >
                                                                        <Icon.Copy className="link-icon" />
                                                                    </button>

                                                                    {/* JOIN */}
                                                                    {mocktest?.join_url ? (
                                                                        <a
                                                                            className="btn p-0"
                                                                            href={mocktest.join_url}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            title="Join Meeting"
                                                                        >
                                                                            <Icon.ExternalLink className="link-icon" />
                                                                        </a>
                                                                    ) : (
                                                                        <button className="btn p-0" disabled title="Join URL not available">
                                                                            <Icon.ExternalLink className="link-icon text-muted" />
                                                                        </button>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <span>N/A</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                {/* EDIT */}
                                                                <Link
                                                                    className="btn p-2"
                                                                    to={`/zoom-meeting/edit/${mocktest.id}`}
                                                                    title="Edit Meeting"
                                                                >
                                                                    <Icon.Edit className="link-icon" />
                                                                </Link>

                                                                {/* DELETE */}
                                                                <button
                                                                    className="btn p-2"
                                                                    title="Delete Meeting"
                                                                    onClick={() => handleDelete(mocktest.id)}
                                                                >
                                                                    <Icon.Trash className="link-icon text-danger" />
                                                                </button>

                                                                <button
                                                                    className="btn p-2"
                                                                    title="View Occurrences"
                                                                    onClick={() => handleViewOccurrences(mocktest)}
                                                                >
                                                                    <Icon.Calendar className="link-icon" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-12 col-md-7">
                                        <div className="dataTables_info" id="dataTableExample_info" role="status" aria-live="polite">
                                            {showTotal}
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-5">
                                        <div className="dataTables_paginate paging_simple_numbers" id="dataTableExample_paginate">
                                            <ResponsivePagination current={currentPage} total={totalPages} onPageChange={handlePageClick} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout >
    )
}

export default ZoomMeeting;